export function calculateAge(dateOfBirthString: string) {
  const today = new Date();
  const dob = new Date(dateOfBirthString); // Assuming dateOfBirthString is in a valid Date constructor format like "YYYY-MM-DD"

  let age = today.getFullYear() - dob.getFullYear();
  const monthDifference = today.getMonth() - dob.getMonth();

  // Adjust age if birthday hasn't occurred this year
  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < dob.getDate())
  ) {
    age--;
  }

  return age;
}
